import _ from 'lodash';
import React from 'react';
import { PropTypes } from '~/utils';

const style = {
  fontFamily      : 'courier, monospace',
  backgroundColor : '#eee',
};

export function Dump( { data, children } ) {
  const obj = data || children;
  const str = JSON.stringify( obj, null, 2 ).replace( /</gu, '&lt;' );
  return <pre><code style={style}>{str}</code></pre>;
}
Dump.propTypes = {
  data      : PropTypes.any,
  children  : PropTypes.any,
};
